import { ISystemNotification } from "@monorepo/monitoring/src/views/SystemNotificationsList/types/SystemNotification";
import { fields } from "@monorepo/utils/src/variables/projectsData/systemNotificationsList/fields";

export const convertStatus = (notificationIsDeleted: boolean): string => (!notificationIsDeleted ? "Активный" : "Удален");

export const convertApiItemToUi = (item: ISystemNotification): ISystemNotification => ({
  ...item,
  status: convertStatus(!!item[fields.SYSTEM_NOTIFICATION_IS_DELETED as keyof ISystemNotification]),
});
